import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZebraPrintSelector = _resolveComponent("ZebraPrintSelector")!

  return (_ctx.user.role?.name === 'Responsabile Magazzino' || _ctx.user.role?.name === 'Master')
    ? (_openBlock(), _createBlock(_component_ZebraPrintSelector, { key: 0 }))
    : _createCommentVNode("", true)
}